<template>
  <section class="main-container search text-center pt-10 pb-20 px-5 md:px-10 mx-auto" :class="{'flex items-center justify-center':isLoadingInProgress}">
    <div
      class="mx-auto text-left mb-10 mt-10"
    >
    <CounterpartyComponent />
    </div>
  </section>
</template>

<script>
import {defineComponent} from "vue";
import CounterpartyComponent from '@/components/common/CounterpartyComponent';

export default defineComponent({
  name: 'CounterpartyWrapper',
  components: {
    CounterpartyComponent,
  },
})
</script>

<style scoped>
.main-container {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>
